<template>
  <div class="logo-wrapper">
    <div class="d-flex">
      <img :src="getIconPath()" class="logo__text" alt v-if="getIconPath() !== null" />
      <img :src="getNamePath()" class="logo__dots" alt v-if="getNamePath() !== null" />
    </div>
    <div class="d-flex" v-if="getSponsorPath() !== null">
      <img :src="getSponsorPath()" class="logo__sponsoren" alt />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    templateKey: String,
  },
  methods: {
    getIconPath() {
      try {
        return require('@/assets/images/' + this.templateKey + '/logo-brand_icon.jpg')
      } catch (err) {
        return null
      }
    },
    getNamePath() {
      try {
        return require('@/assets/images/' + this.templateKey + '/logo-brand_name.jpg')
      } catch (err) {
        return null
      }
    },
    getSponsorPath() {
      try {
        return require('@/assets/images/' + this.templateKey + '/sponsoren-logos.jpg')
      } catch (err) {
        return null
      }
    }
  }
};
</script>

<style lang="scss">
.logo-wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;

  .logo {
    &__text {
      margin-right: 2.5rem;
    }

    &__sponsoren {
      max-width: 300px;
      margin: 0;
    }
  }
}

@media only screen and (min-width: 600px) {
  .logo {

    &__text,
    &__dots {
      height: 2.5rem;
    }
  }
}

@media print {
  .logo {
    &__sponsoren {
      margin-bottom: 10px;
    }
  }
}
</style>
